import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private httpClient: HttpClient) {
  }

  getOrganizations() {
    return this.httpClient.get('/systemconfig/organization/');
  }

  getOrganization(id) {
    return this.httpClient.get('/systemconfig/organization/',{params:{id}});
  }

  postOrganization(organisation_data) {
    return this.httpClient.post('/systemconfig/organization/', organisation_data);
  }

  updateOrganization(organisation_data) {
    return this.httpClient.post('/systemconfig/organization/', organisation_data);
  }

  getactiveorganization() {
    return this.httpClient.get('/systemconfig/getactiveorganization/');
  }

  deleteimage(type,organization_id){
    return this.httpClient.delete('/systemconfig/organization/',{params:{organization_id,type}});
  }

  getOrganizationsInfo(){
    return this.httpClient.get('/systemconfig/get_organization_info/')
  }


}
